// extracted by mini-css-extract-plugin
export default {"leadership-hero-section":"leadership_leadership-hero-section__TU6UW","leaders-section":"leadership_leaders-section__irKnb"};